export default "__VITE_ASSET__jTjA7hng__"